import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '!=': [
                {
                  '@': 'editingSubaward',
                },
                null,
              ],
            },
            'Edit Subaward',
          ],
          'Create New Subaward',
        ],
      },
      type: 'details',
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'code',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!subawards#!subaward:!code',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'name',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!subawards#!subaward:!name',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'subrecip',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'subrecip',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!subrecip',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'subrecip_pi',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'subrecip_pi',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!subrecip_pi',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'proj',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'proj',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!subawards#!subaward:!proj',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'admin_contact',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'admin_contact',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!admin_contact',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'invoice_contact',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'invoice_contact',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!invoice_contact',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'authorized_contact',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'authorized_contact',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!authorized_contact',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'budget_period',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'budget_period',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!budget_period',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'curr_amount',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'curr_amount',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!curr_amount',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'total_amount',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'total_amount',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!total_amount',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'perf_address',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'perf_address',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!perf_address',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'admin_address',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'admin_address',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!admin_address',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'pay_address',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'pay_address',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!pay_address',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'fin_contact',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubaward',
                      },
                      'fin_contact',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subawards#!subaward:!fin_contact',
                        },
                      },
                    },
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'sr.save-subaward',
                },
              },
              variables: {
                '{}': {
                  subawardId: {
                    '@$': 'subawardId',
                  },
                  subawardCode: '${field:code}',
                  subawardName: '${field:name}',
                  subawardSubrecip: '${field:subrecip}',
                  subawardSubrecipPi: '${field:subrecip_pi}',
                  subawardProj: '${field:proj}',
                  subawardAdminContact: '${field:admin_contact}',
                  subawardInvoiceContact: '${field:invoice_contact}',
                  subawardAuthorizedContact: '${field:authorized_contact}',
                  subawardBudgetPeriod: '${field:budget_period}',
                  subawardCurrAmount: '${field:curr_amount}',
                  subawardTotalAmount: '${field:total_amount}',
                  subawardPerfAddress: '${field:perf_address}',
                  subawardAdminAddress: '${field:admin_address}',
                  subawardPayAddress: '${field:pay_address}',
                  subawardFinContact: '${field:fin_contact}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    editingSubaward: {
      selection: {
        '{}': {
          code: {
            '@.': '!code',
          },
          name: {
            '@.': '!name',
          },
          subrecip: {
            '@.': '!subrecip',
          },
          subrecip_pi: {
            '@.': '!subrecip_pi',
          },
          proj: {
            '@.': '!proj',
          },
          admin_contact: {
            '@.': '!admin_contact',
          },
          invoice_contact: {
            '@.': '!invoice_contact',
          },
          authorized_contact: {
            '@.': '!authorized_contact',
          },
          budget_period: {
            '@.': '!budget_period',
          },
          curr_amount: {
            '@.': '!curr_amount',
          },
          total_amount: {
            '@.': '!total_amount',
          },
          perf_address: {
            '@.': '!perf_address',
          },
          admin_address: {
            '@.': '!admin_address',
          },
          pay_address: {
            '@.': '!pay_address',
          },
          fin_contact: {
            '@.': '!fin_contact',
          },
        },
      },
      target: 'ent:!subawards:!subaward',
      quantity: 1,
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'subawardId',
          },
        ],
      },
    },
  },
}
